<template>
	<main v-if="simplePage">
		<slot />
	</main>
	<main v-else>
		<!-- Login/registration headers -->
		<StickyHeaderSimple v-if="currentPath.indexOf('login') > -1 || currentPath.indexOf('reset-password') > -1">
			<BaseButton @click="navigateToRegistration" :subtitle="$t('forUsers')" class="capitalize ml-4">
				{{ $t("registerBtn") }}
			</BaseButton>
		</StickyHeaderSimple>
		<StickyHeaderSimple v-else-if="currentPath.indexOf('registration') > -1">
			<BaseButton @click="navigateTologin" type="tertiary" class="capitalize ml-6">
				{{ $t("loginBtn") }}
			</BaseButton>
		</StickyHeaderSimple>

		<StickyHeaderOnepager v-else-if="currentPath.indexOf('employer-branding') > -1" />

		<!-- Basic Header -->
		<StickyHeader v-else />
		<slot />

		<!-- <SectionsSubscribeCta v-if="!globalConfig.isBlue"/> -->
		<SectionsFooter />
	</main>
</template>

<script lang="ts">
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { defineComponent, computed, ref, onMounted, provide } from "vue";

export default defineComponent({
	setup() {
		const { locale } = useI18n();
		const route = useRoute();
		const router = useRouter();
		const region = ref("");

		const currentPath = computed(() => {
			return router.currentRoute.value.path;
		});

		const redirectTarget = computed(() => route.query.r);

		const simplePage = computed(() => !!route.query.simplePage);
		provide("simplePage", simplePage);

		const navigateToRegistration = () => {
			const queryString = redirectTarget.value ? `?r=${redirectTarget.value}` : "";
			router.push(`/${locale.value}/registration${queryString}`);
		};

		const navigateTologin = () => {
			const queryString = redirectTarget.value ? `?r=${redirectTarget.value}` : "";
			router.push(`/${locale.value}/login${queryString}`);
		};

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;

			// TODO - remove this when the verification is not needed anymore
			if (region.value === "RO") {
				useHead({
					meta: [
						{
							name: "google-site-verification",
							content: "xCMTSho3ZJsKHij9K14TZAA5iFNTpET95jU9s4UclYQ",
						},
					],
				});
			}
		});

		return {
			simplePage,
			locale,
			currentPath,
			region,
			redirectTarget,
			navigateToRegistration,
			navigateTologin,
		};
	},
});
</script>
